var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('img',{staticClass:"image_4",attrs:{"referrerpolicy":"no-referrer","src":require("./assets/img/SketchPngcdda314e1acd1a34bdc59b58990099c11b2b5edf3156159e051c877d22e08726.png")}})])
}]

export { render, staticRenderFns }